import {Button, Group, Modal, Textarea} from '@mantine/core';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

interface EditConditionDescriptionModalProps {
  opened: boolean;
  descriptionDraft: string;
  onClose: () => void;
  onDescriptionDraftChange: (description: string) => void;
  onSave: () => void;
}

export function EditConditionDescriptionModal({
  opened,
  descriptionDraft,
  onDescriptionDraftChange,
  onClose,
  onSave,
}: EditConditionDescriptionModalProps): JSX.Element {
  const handleDescriptionChange = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
    onDescriptionDraftChange(event.currentTarget.value);
  };

  const handleDescriptionKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>): void => {
    if (event.key === 'Enter' && !event.nativeEvent.isComposing) {
      event.preventDefault();
      onSave();
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Edit condition description">
      <Textarea
        minRows={4}
        value={descriptionDraft}
        onChange={handleDescriptionChange}
        onKeyDown={handleDescriptionKeyDown}
        aria-label="Description"
        {...getTestProps({component: 'TransposedReplicateTable', element: 'editDescriptionTextarea'})}
      />
      <Group position="right" mt="md">
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onSave}>Save</Button>
      </Group>
    </Modal>
  );
}
